import React from "react"
import * as PropTypes from "prop-types"

import Deals from "./userMenuContexts/Deals"
import Recognition from "./userMenuContexts/Recognition"

const UserMenuContext = (props, {apps, appPath}) => {
  switch (appPath) {
    case apps.PERKS:
    case apps.SEARCH:
      return <Deals />
    case apps.RECOGNITION:
      return <Recognition />
    default:
      return null
  }
}

UserMenuContext.contextTypes = {
  apps: PropTypes.object.isRequired,
  appPath: PropTypes.string.isRequired
}

export default UserMenuContext
